import { useEffect, useState } from "react";
import Input from "./admin/input";
import uuidv4 from "../tools/guidgenerator";
import * as Constants from "../config";
import * as Vaules from "../static data/selectvalues";
import { useLocation } from "react-router-dom";
import { checkArrayDefined } from "../tools/valueshelper";
import { useTranslation } from "react-i18next";

export default function ContactUs(props){
        const { t } = useTranslation();
    const datar = {
        name:"",
        phone:"",
        email:"",
        message:"",
        link:""
    }

    const validationErrorData = {
        name:false,
        email:false,
        phone:false,
    }
    
    const location = useLocation();  

    const [data,setData] = useState(datar);
    const [validationError, setValidationError] = useState(validationErrorData);
    const [hasValidationError, setHasValidationError] = useState(false);
    const [messageSent, setMessageSent] = useState(false);

    const validate = () => {
        let haserror = false;
        let validationErrorNew = {};
        if(!data.email.match("[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"))
        {
            haserror = true;
            validationErrorNew.email = true;
        }
        else
            validationErrorNew.email = false;
        if(data.phone.length < 6 || data.phone.length > 30)
        {
            haserror = true;
            validationErrorNew.phone = true;
        }
        if(validationErrorNew.phone && !validationErrorNew.email)
        {
            validationErrorNew.phone = false;
            haserror = false;
        }
        if(validationErrorNew.email && !validationErrorNew.phone)
        {
            validationErrorNew.email = false;
            haserror = false;
        }
        if(data.name.length < 2 || data.name.length > 30)
        {
            haserror = true;
            validationErrorNew.name = true;
        }

        setValidationError(validationErrorNew);
        setHasValidationError(haserror);
        return haserror;
    }


    const onValueChange = (e) =>{        
        const { id, name, value } = e.target;        
        setData({...data, [name]: value});   
    }

    useEffect(() => {
        if(hasValidationError) validate();
     }, [data]);

    const saveData = () => {
        if(validate()) return;
        let savedataObj = {};
        Object.assign(savedataObj,data);
        savedataObj.link = window.location.href;
        if(checkArrayDefined(props.service))
            savedataObj.service = props.service;
        const body = Constants.requestBody(savedataObj);
        fetch(Constants.apiurl + Constants.sendcontactinfo, body)
        .then(response => {            
            setMessageSent(true);
            return response.json();
        })
        .then(data => {            
        })
        .catch(err => {
            console.log(err.error);
        });
    }

    const sendData =                 
    <div>
        <div onClick={props.closeModal} className='close-icon-main'>X</div>
        <div id="modal-header">{t('Contactez un de nos agent')}</div>
        { checkArrayDefined(props.service) ?
            <div id="input-block-modal" className="hardlined">
                <label >{t('Service :')}</label>
                <div className="bolded">{props.service}</div>
            </div>
            :""
        }
        <div id="input-block-modal">
            {validationError.name ?
                <label className="error-label">Nom d'entrée</label>
                :
                ""
            }
            <label >{t("Nom :")}</label>
            <input value={data.name} name='name' onChange={onValueChange}/>
        </div>
        <div id="input-block-modal">                        
            {validationError.phone ?
                <label className="error-label">Téléphone d'entrée</label>
                :
                ""
            }
            <label>{t('Numéro de téléphone :')}</label>                       

            <input value={data.phone} name='phone' onChange={onValueChange}/>
        </div>
        <div id="input-block-modal">                        
            {validationError.email ?
                <label className="error-label">Entrez l'adresse e-mail correcte</label>
                :
                ""
            }
            <label>{t('Email :')}</label>
            <input value={data.email} name='email' onChange={onValueChange}/>
        </div>
        <div id="input-block-modal">                        
            <label>Message :</label>
            <textarea value={data.message} name='message' onChange={onValueChange}/>
        </div>
        <div onClick={saveData} className="blue-button">{t('Soumettre')}</div>
    </div>;

    return(
        <>
            <div className="modal-window-small">
                {messageSent ? 
                <>        
                    <div>
                        <div onClick={props.closeModal} className='close-icon-main'>X</div>
                        <div id="modal-header">{t('Votre message a été envoyé')}</div>
                        <div  onClick={props.closeModal}  className="blue-button">OK</div>
                    </div>
                </>
                :
                sendData}
            </div>
        </>
    )
}